import { Dispatch, FC, SetStateAction, useState } from 'react';
import { Hr } from 'src/components/_commons';
import { millisecondsOneDay } from '@monorepo/helpers';
import { NotificationsMeetingCleaning } from './commons/NotificationsMeetingCleaning';
import { NotificationsSettings } from './commons/NotificationsSettings';
import { NotificationsSpecialOptions } from './commons/NotificationsSpecialOptions';
import { NotificationsTitle } from './commons/NotificationsTitle';
import { typeNotificationsDoc, typeMeetingsDoc, typeNotificationSetting, typeUser } from '@monorepo/models';

type propsType = {
    meetingsDoc: typeMeetingsDoc;
    notificationsDoc: typeNotificationsDoc;
    setRefreshCounter: Dispatch<SetStateAction<number>>;
    users: typeUser[];
};

export const NotificationsMeetingsMidweekCleaning: FC<propsType> = ({ meetingsDoc, notificationsDoc, setRefreshCounter, users }) => {
    const [newNotificationSettings, setNewNotificationSettings] = useState<typeNotificationSetting[]>(notificationsDoc.midweekCleaning);
    const [sendOnlyToOverseerAndAssistance, setSendOnlyToOverseerAndAssistance] = useState(!!notificationsDoc.midweekCleaningSendOnlyToOverseerAndAssistance);
    const meetings = meetingsDoc.midweeks
        .filter(m => new Date(m.date).getTime() > new Date().getTime() - millisecondsOneDay)
        .filter(m => m.groupsForCleaning.some(g => g))
        .sort((m1, m2) => new Date(m1.date).getTime() - new Date(m2.date).getTime())
    ;
    const type = 'meetings-midweek-cleaning';

    return (
        <div>
            <NotificationsTitle
                type={type}
            />
            <NotificationsSpecialOptions
                cancelHandler={() => {
                    setSendOnlyToOverseerAndAssistance(!!notificationsDoc.midweekCleaningSendOnlyToOverseerAndAssistance);
                }}
                getNewNotificationsDoc={() => {
                    const sc = structuredClone(notificationsDoc)
                    sc.midweekCleaningSendOnlyToOverseerAndAssistance = sendOnlyToOverseerAndAssistance;
                    return sc;
                }}
                options={[
                    {
                        changeOption: () => setSendOnlyToOverseerAndAssistance(x => !x),
                        label: 'Enviar las notificaciones solamente al Superintendente y al Auxiliar del Grupo',
                        originalValue: !!notificationsDoc.midweekCleaningSendOnlyToOverseerAndAssistance,
                        value: sendOnlyToOverseerAndAssistance
                    }
                ]}
                setRefreshCounter={setRefreshCounter}
                type={type}
            />
            <NotificationsSettings
                head1Id={null}
                head1OriginalId={null}
                head2Id={null}
                head2OriginalId={null}
                notificationsDoc={notificationsDoc}
                notificationSettings={notificationsDoc.midweekCleaning}
                newNotificationSettings={newNotificationSettings}
                setNewNotificationSettings={setNewNotificationSettings}
                setRefreshCounter={setRefreshCounter}
                type={type}
                updateHead1Id={() => {}}
                updateHead2Id={() => {}}
                users={users}
            />

            <Hr classes={'my-5'} />

            <NotificationsMeetingCleaning
                meetings={meetings}
                onlyToOverseerAndAssistance={!!notificationsDoc.midweekCleaningSendOnlyToOverseerAndAssistance}
                users={users}
            />
        </div>
    );
}
